import React, { useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import Alert from "../../Components/Alert/Alert";
import Testimonies from "../../Components/Testimonies/Testimonies";
import "./Home.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { useForm, ValidationError } from "@formspree/react";

//Videos
import frugalVideo from "../../Assets/Images/frugal_promo.mov";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";

// import required modules
import { Pagination, Autoplay } from "swiper";

import Accordion from "react-bootstrap/Accordion";

// Background Images
import chair from "../../Assets/Images/chair.png";
import watch from "../../Assets/Images/watch.png";
import pool from "../../Assets/Images/pool.png";
import camera from "../../Assets/Images/camera.png";
import xbox from "../../Assets/Images/xbox.png";
import drone from "../../Assets/Images/drone.png";
import sneaker from "../../Assets/Images/sneaker.png";
import priceErrors from "../../Assets/Images/priceerrors.png";
import eclipse1 from "../../Assets/Images/eclipse1.png";
import eclipse2 from "../../Assets/Images/eclipse2.png";
import twitter from "../../Assets/Images/twitter.png";
// Icons
import dollarCoin from "../../Assets/Icons/dollarCoin.svg";
import checkPurple from "../../Assets/Icons/checkPurple.svg";
import checkGrey from "../../Assets/Icons/checkGrey.svg";
import onlineIcon from "../../Assets/Icons/online.png";
import bounties from "../../Assets/Icons/bounties.png";

//Background Images

import backgroundImg1 from "../../Assets/Images/backgroundImg1.png";

function Landing() {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  function ContactForm() {
    const [state, handleSubmit] = useForm("mdojlloy");
    if (state.succeeded) {
      return <p style={{ fontWeight: "bold" }}>Thanks for joining!</p>;
    }
    return (
      <form onSubmit={handleSubmit} className="form-group">
        <input
          id="email"
          type="email"
          name="email"
          className="inputEmail"
          placeholder="Enter your email"
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <button type="submit" disabled={state.submitting} className="submitBtn">
          Sign Up
        </button>
      </form>
    );
  }

  return (
    <div id="landing">
      <button className="sectionBtn">Premium Group</button>
      <a
        id="animatedBox"
        className="sneakerContainer"
        href="https://twitter.com/frugalszn/status/1559015536515723266?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img
          id="containerImg"
          src={sneaker}
          className="sneakerImg"
          alt="camera"
        />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="makeWhite">K-Swiss Sneaker</h4>
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$78</s> $0.01</span>
        </h4>
      </a>
      <a
        id="animatedBox"
        className="chairContainer"
        href="https://twitter.com/frugalszn/status/1545518083976024064?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img id="containerImg" className="chairImg" src={chair} alt="camera" />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$300</s> $0</span>
        </h4>
      </a>
      <a
        id="animatedBox"
        className="watchContainer"
        href="https://twitter.com/frugalszn/status/1515778782451314689?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img id="containerImg" className="watchImg" src={watch} alt="camera" />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="makeWhite">Apple Watch</h4>
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$359</s> $14</span>
        </h4>
      </a>
      <a
        id="animatedBox"
        className="xboxContainer"
        href="https://twitter.com/frugalszn/status/1540361942568554496?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img id="containerImg" src={xbox} className="xboxImg" alt="camera" />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="makeWhite">Xbox</h4>
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$580</s> $44</span>
        </h4>
      </a>
      <a
        id="animatedBox"
        className="poolContainer"
        href="https://twitter.com/frugalszn/status/1541112390221066241?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img id="containerImg" src={pool} className="poolImg" alt="pool" />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="makeWhite">Intex Pool</h4>
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$240</s> $30</span>
        </h4>
      </a>
      <a
        id="animatedBox"
        className="droneContainer"
        href="https://twitter.com/frugalszn/status/1539804222295642114?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
        target="_blank"
        rel="noreferrer"
      >
        <img id="containerImg" src={drone} className="poolImg" alt="camera" />
        <img className="animateTwitter" src={twitter} alt="twitter" />
        <h4 className="makeWhite">DJI Mini</h4>
        <h4 className="savings makeWhite">
          <span className="boldText makeWhite"><s className="strikeThrough">$350</s> $8.66</span>
        </h4>
      </a>
      <div className="landingContainer">
        {/* <button className="sectionBtn">FRUGAL SEASON</button> */}
        <h1 className="landingHeader">
          {/* A cook group built for hustlers, */}
          <span className="landingMoto">Frugal Season</span>
          {/* <span className="forHustlers"> for hustlers</span> */}
        </h1>
        <p className="sectionText">
          Premium Subscription platform filled with entrepreneurial secrets. A
          different e-commerce experience where hustlers are built.
        </p>
        <ContactForm />
        {/* <form className="form-group">
        <input
          type="text"
          className="inputEmail"
          placeholder="Enter your email"
        />
        <button className="submitBtn">Sign Up</button>
      </form> */}

        <a
          className="successItem"
          href="https://twitter.com/frugalszn/status/1546947504360591363?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
          target="_blank"
          rel="noreferrer"
        >
          <img className="cameraImg" src={camera} alt="camera" />
          <div className="itemDescription">
            <h2 className="savingText makeWhite">
              <span>97% </span> {/* className="purpleText" */}
              off
            </h2>
            <hr className="makeWhite" />
            <div className="pricingSection">
              <h3 className="sideText makeWhite">Retail</h3>
              <h3 className="itemPrice makeWhite"><s className="strikeThrough">$400</s></h3>
            </div>
            <div className="pricingSection">
              <h3 className="sideText makeWhite">Purchased</h3>
              <h3 className="itemPrice makeWhite boldText">$15</h3>
            </div>
          </div>
        </a>

        <div className="sliderSuccess">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1}
            loop={true}
            // noSwiping={true}
            autoplay={{ delay: 1, disableOnInteraction: false }}
            // preventInteractionOnTransition={true}
            speed={1500}

          >
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1546947504360591363?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="cameraImg" src={camera} alt="camera" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">
                    <span>Insta 360 Camera </span> {/* className="purpleText" */}
                  </h2>
                  <hr className="makeWhite" />
                  {/* <div className="pricingSection">
                    <h3 className="sideText makeWhite">Retail</h3>
                    <h3 className="itemPrice makeWhite">$400</h3>
                  </div>
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite">Bought for</h3>
                    <h3 className="itemPrice makeWhite">$15</h3>
                  </div> */}
                  <h3 className="sideText makeWhite"><s className="strikeThrough">$400</s> $15</h3>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1515778782451314689?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sneakerImg" src={watch} alt="watch" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">Apple Watch</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$359</s> $14</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1559015536515723266?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sneakerImg" src={sneaker} alt="sneaker" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">K-Swiss Sneaker</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$78</s> $0.01</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1545518083976024064?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="chairImgSlider" src={chair} alt="chair" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">Office Chair</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$300</s> $0</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1539804222295642114?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sneakerImg" src={drone} alt="drone" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">DJI Mini</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$350</s> $8.66</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1540361942568554496?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="cameraImg" src={xbox} alt="xbox" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">Xbox</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$580</s> $44</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
            <SwiperSlide className="slide">
              <a
                className="successItem"
                href="https://twitter.com/frugalszn/status/1541112390221066241?s=21&t=bqy7FKuAKFaGeuFRSAJMQg"
                target="_blank"
                rel="noreferrer"
              >
                <img className="sneakerImg" src={pool} alt="pool" />
                <div className="itemDescription">
                  <h2 className="savingText makeWhite">Intex Pool</h2>
                  <hr className="makeWhite" />
                  <div className="pricingSection">
                    <h3 className="sideText makeWhite"><s className="strikeThrough">$240</s> $30</h3>
                  </div>
                </div>
              </a>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
}

function Analytics() {
  return (
    <div id="analytics">
      <div className="analyticGrid">
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div className="analyticContainer">
              <h2 className="statAnimate">
                {isVisible ? (
                  <CountUp
                    prefix="$"
                    start={0}
                    end={25}
                    suffix="M+"
                    duration="1"
                  />
                ) : null}
              </h2>
              <p>Profit Made</p>
            </div>
          )}
        </VisibilitySensor>

        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div className="analyticContainer">
              <h2 className="statAnimate">
                {isVisible ? (
                  <CountUp start={0} end={1000} suffix="+" duration="1" />
                ) : null}
              </h2>
              <p>Active Users</p>
            </div>
          )}
        </VisibilitySensor>

        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div className="analyticContainer">
              <h2 className="statAnimate">
                {isVisible ? (
                  <CountUp start={0} end={95} suffix="%" duration="1" />
                ) : null}
              </h2>
              <p>Retention Rate</p>
            </div>
          )}
        </VisibilitySensor>
      </div>
    </div>
  );
}

function Features() {
  return (
    <div id="features">
      <button className="sectionBtn">Features</button>
      <h1 className="headerText">Features to help you cook</h1>
      <p className="sectionText">
        Below you can get a glimpse on what we have to offer. Our goal is to
        diversify your income streams through a wide variety of features &
        services. We want to build the next entrepreneur & believe we can put
        you in the right direction.
      </p>

      <div className="featuresGrid">
        <div className="featureContainerOuter">
          <div className="featureContainerInner">
            <img src={priceErrors} alt="Feature Icon" className="featureIcon" />
            <h2 className="featureTitle">Price Errors</h2>
            <p className="featureBody">
              Stores and retailers are never 100% perfect. So believe it when we
              tell you, they incorrectly list prices on products quite often.
              Allow us to source for you and deliver products right within your
              fingertips.
            </p>
          </div>
        </div>
        <div className="featureContainerOuter">
          <div className="featureContainerInner">
            <img src={onlineIcon} alt="Feature Icon" className="featureIcon" />
            <h2 className="featureTitle">Retail / Online Arbitrage</h2>
            <p className="featureBody">
              If you think there’s no money to make off products sold in store &
              online retailers you are wrong. We find products where demand
              exceeds supply. Allowing you to make a profit on over 50+ leads
              daily from experienced individuals.
            </p>
          </div>
        </div>
        <div className="featureContainerOuter">
          <div className="featureContainerInner">
            <img src={bounties} alt="Feature Icon" className="featureIcon" />
            <h2 className="featureTitle">Bug Bounties</h2>
            <p className="featureBody">
              It is highly unlikely that sites are made flawless. With our
              expert developers and bounty hunting team, we are always on the
              look out to obtain free products, rewards, and perks you would
              have never imagined were possible through automation. Making the
              impossible, possible.
            </p>
          </div>
        </div>
      </div>
      <div className="otherMethods">
        <img src={dollarCoin} alt="coin" className="socialLogo" />+ much more
      </div>
    </div>
  );
}
function About() {
  return (
    <div id="about">
      <div className="videoContainer">
        <div className="videoContainerArea">
          <video
            webkit-playsInline
            playsInline
            autoPlay
            muted
            loop
            controls
            className="video"
            width="100%"
            height="auto"
            src={frugalVideo}
            type="video/mp4"
          />
        </div>
        <img className="eclipse1" src={eclipse1} alt="eclipse" />
        <img className="eclipse2" src={eclipse2} alt="eclipse" />
      </div>
      <div className="aboutContent">
        <button className="sectionBtn">About</button>
        <div className="aboutText">
          <h1 className="headerText">About us and our mission</h1>
          <p className="sectionText">
            We are a team of over 50+ Entrepreneurs and deal hunters catered to
            bring you the best money making opportunities possible. With years
            of experience and access to the most extensive network of
            experienced & successful individuals in this niche, we knew the
            community has tons of space to grow. It is time to become a player
            in your own book and we are here to put you in shape.
          </p>
          <hr />
          <div className="aboutUsItems">
            <div className="aboutUs">
              <img src={checkPurple} alt="checkMark" />
              <p className="aboutUsText">Founded by hustlers</p>
            </div>
            <div className="aboutUs">
              <img src={checkPurple} alt="checkMark" />
              <p className="aboutUsText">10+ years experience</p>
            </div>
            <div className="aboutUs">
              <img src={checkPurple} alt="checkMark" />
              <p className="aboutUsText">Dedicated to your success</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Join() {
  return (
    <div id="join">
      <button className="sectionBtn">Standard Membership</button>
      <div className="joinContent">
        <h1>Get Standard</h1>
        <p className="sectionText">
          Curious in knowing what benefits comes with your membership? Take a
          look below!
        </p>
        <div className="membershipBox">
          <div className="membershipBoxHeader">
            <span className="planEmoji">💰</span> <span>LOW IN STOCK</span>
          </div>
          <div className="membershipBoxContent">
            <h3 className="membershipText">Membership</h3>
            <h2 className="price">
              $75<span className="perMonth"> /mo</span>
            </h2>
            <div className="membershipDetails">
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">Price errors </p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">Retail / online arbitrage</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">Bug Bounties</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">50+ Retail Monitors</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">Custom tools</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">1-on-1 support</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">Founded by hustlers</p>
              </div>
              <div className="membershipDetail">
                <img src={checkGrey} alt="checkMark" />
                <p className="aboutUsText">10+ years experience</p>
              </div>
            </div>
            <form>
              <a href="https://whop.com/frugal-szn-1">
                <div className="btn joinNowBtn text-nowrap">Join Now</div>
              </a>
            </form>
          </div>
        </div>
        {/* <form className="form-group">
          <input
            type="text"
            className="inputEmail"
            placeholder="Enter your email"
          />
          <button className="submitBtn">CTA Here</button>
  </form> */}
      </div>
    </div>
  );
}

function Testimonials() {
  const pagination = {
    clickable: true,
    bulletClass: `swiper-pagination-bullet`,
  };
  return (
    <div id="testimonials">
      <div className="testimonyText">
        <button className="sectionBtn">Testimonials and FAQ’s </button>
        <h1 className="headerText">Testimonials and FAQs</h1>
        <p className="sectionText">
          Not convinced? Check out what our premium members have to say about
          frugal season.
        </p>
      </div>
      <div className="sliderTestimonies">
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: true,
          }}
          speed={700}
          spaceBetween={30}
          pagination={pagination}
          className="mySwiper"
          breakpoints={{
            // when window width is >= 300px
            300: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            // when window width is >= 1100px
            1200: {
              slidesPerView: 1.5,
              spaceBetween: 30,
            },
          }}
        >
          <SwiperSlide className="slide">
            <Testimonies
              review="Frugal has changed my life for the better. With frugal you NEVER miss a deal. the people here work around the clock to make sure all your needs are met. I couldn't ask for a better group "
              // memberType="Frugal SZN Discord Member"
              user="TheLazyITGuy#0002"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="Frugal is the best group to ever do it I’ve here for maybe 2 months max and they helped me make over 8k while having a fun and supportive community"
              // memberType="Frugal SZN Discord Member"
              user="KingCobra#5485"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="Made well over my $75 fee within a week of joining. There’s only been profit and it only gets better from here on out. Just make sure you’re actively engaged and put your time into it if you really want to make your money back. FRUGAL GO BRRR"
              // memberType="Frugal SZN Discord Member"
              user="garreness#0909"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="3 weeks into joining frugal i have easily made 300$, frugal has gave me access to amazing deals and steals that are around the clock. I work a 10 hour shift at my day job and when i get off i know i can get on frugal and find good deals to flip. The staff is amazing and very helpful, frugal isn’t just a group it’s a family!"
              // memberType="Frugal SZN Discord Member"
              user="djj#0001"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="To all you out there debating wether to join or not...JOIN!  i was super skeptical joining this group bc it just seemed to good to be true, and price point kinda made me hesitate. but after joining this group i left all others. i literally made hundreds in pure profit in a month! you could do it in a day tho tbh. If its not money making deals its constant all day personal deals/steals that you arent gna find any where else."
              // memberType="Frugal SZN Discord Member"
              user="JoeyAR15#9517"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="One of the best groups I've ever joined. You make ALL of your money back if you just take a couple minutes out of the day and put in a little effort. I've made well over $1000 with the past couple months I've been in Frugal. Y'all are sleeping on a lot of deals if you don't have frugal. Hands down the best community I've ever been in."
              // memberType="Frugal SZN Discord Member"
              user="Nobodyknows#2158"
            />
          </SwiperSlide>
          <SwiperSlide>
            <Testimonies
              review="I literally joined Frugal yesterday and I’ve already ordered about $180 worth of stuff for FREE. You are actually slacking if you haven’t joined here yet. IT IS WORTH THE $75"
              // memberType="Frugal SZN Discord Member"
              user="Skyflyer#4709"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}

function Faq() {
  return (
    <div id="faq">
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Can I cancel anytime?</Accordion.Header>
          <Accordion.Body>
            We make it extremely easy for you to cancel directly through your
            dashboard. Don’t like it? Give us some{" "}
            <a href="https://whop.com/hub?login=true">feedback</a> and let us
            know how we can improve. We hope to see you back again soon!
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>Can I become a staff member?</Accordion.Header>
          <Accordion.Body>
            Yes of course, we are always looking to expand the team. Feel free
            to fill out this form to{" "}
            <a href="https://forms.gle/PQ2sNCXDWRdsV5jN7">apply</a>. All
            positions are paid!
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            I’m new to this, how can I get started?
          </Accordion.Header>
          <Accordion.Body>
            Glad to have you here, we have a very extensive guide on how to
            navigate our platform for anyone who is new along with a system that
            allows our staff to work 1-on-1. Our goal is to deliver service the
            right way.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            I had a horrible experience, who can I contact for help?
          </Accordion.Header>
          <Accordion.Body>
            Ouch we certainly don’t like to hear that, please report to us on
            the cancellation feedback form or get in contact directly with our
            team. We really hope to make your experience as pleasant as
            possible. Don’t hesitate to reach out, we take all concerns
            seriously.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

function Team() {
  return (
    <div id="team">
      <button className="sectionBtn">Join the team </button>
      <h1>Join the team</h1>
      <p className="teamText">
        You think you got what it takes to join the team? We are always open to
        new positions. All positions are paid. We would love to continue
        expanding our features and services made available to our premium
        members.
      </p>
      <form>
        <a href="/">
          <a
            className="btn applyNowBtn text-nowrap"
            href="https://forms.gle/PQ2sNCXDWRdsV5jN7"
            target="_blank"
          >
            Apply Now
          </a>
        </a>
      </form>
    </div>
  );
}

function SignUp() {
  function ContactForm2() {
    const [state, handleSubmit] = useForm("mdojlloy");
    if (state.succeeded) {
      return (
        <p style={{ fontWeight: "bold", color: "white" }}>
          Thanks for joining!
        </p>
      );
    }
    return (
      <form onSubmit={handleSubmit} className="form-group">
        <input
          id="email"
          type="email"
          name="email"
          className="inputEmail inputWhite"
          placeholder="Enter your email"
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
        <button type="submit" disabled={state.submitting} className="submitBtn">
          Sign Up
        </button>
      </form>
    );
  }
  return (
    <div id="signUp">
      <h1 className="signUpText">
        Sign up to our email list to get special offers
      </h1>
      <div className="signUpContent">
        <p className="sectionText">
          Premium subscription platform filled with Entrepreneurial secrets.
          Built by hustlers, for hustlers.
        </p>
        <ContactForm2 />
        {/* <form className="form-group">
          <input
            type="text"
            className="inputEmail inputWhite"
            placeholder="Enter your email"
          />
          <button className="submitBtn">Sign Up</button>
        </form> */}
      </div>
    </div>
  );
}

// const MailchimpFormContainer = (props) => {
//   const postUrl = `https://gmail.us9.list-manage.com/subscribe/post?u=49a122821fbe374923f9403cd&id=5408b12402`;

//   return (
//     <div className="mc__form-container">
//       <MailchimpSubscribe url={postUrl} />
//     </div>
//   );
// };

function Home() {
  return (
    <div>
      <Alert />
      <Navbar homeNav="navbar navbar-expand-md navbar-light bg-custom" />
      <Landing />
      <Analytics />
      <Features />
      <About />
      <Join />
      <Testimonials />
      <Faq />
      <Team />
      <SignUp />
      <Footer />
    </div>
  );
}

export default Home;
